import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';

interface RecordCreateDialogProps {
    open: boolean;
    onClose: () => void;
}

const RecordCreateDialog = ({ open, onClose }: RecordCreateDialogProps) => {
    const [web, setWeb] = useState('');
    const [pass, setPass] = useState('');
    const [webError, setWebError] = useState(false);
    const [passError, setPassError] = useState(false);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleCreateUser = async () => {
        if (!web) {
            setWebError(true);
            notify('请输入web', { type: 'warning' });
            return;
        }
        if (!pass) {
            setPassError(true);
            notify('请输入pass', { type: 'warning' });
            return;
        }
        try {
            await dataProvider.create('passwords', {
                data:{ web: web, pass: pass },
            });
            notify('用户创建成功', { type: 'success' });
            refresh();
            onClose();
            setWeb('');
            setPass('');
        } catch (error) {
            notify('创建失败: ' + error, { type: 'warning' });
        }
    };

    return (
        <Dialog open={open} onClose={() => {
            onClose();
            setWeb('');
            setPass('');
            setWebError(false);
            setPassError(false);
        }}>
            <DialogTitle>添加记录</DialogTitle>
            <DialogContent>
                <TextField
                    label="WEB/APP"
                    value={web}
                    onChange={(e) => {
                        setWeb(e.target.value);
                        setWebError(false);
                    }}
                    error={webError}
                    helperText={webError ? 'Web/App不能为空' : ''}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="密码"
                    value={pass}
                    onChange={(e) => {
                        setPass(e.target.value);
                        setPassError(false);
                    }}
                    error={passError}
                    helperText={passError ? '密码不能为空' : ''}
                    fullWidth
                    margin="normal"
                />
               
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCreateUser} color="primary" disabled={!web || !pass}>确认</Button>
                <Button onClick={() => {
                    onClose();
                    setPass('');
                    setWeb('');
                    setPassError(false);
                    setWebError(false);
                }}>取消</Button>
            </DialogActions>
        </Dialog>
    );
};

export default RecordCreateDialog;
